import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseEventMessageDeletedDraft } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventMessageDeletedDraft = () => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handle = (data: IResponseEventMessageDeletedDraft) => {
    conversationStore.deleteItemDraft(data.conversation.id)
  }

  useEffect(() => websocket.on(WebsocketEvent.MessageDeletedDraft, handle), [])
}
